export function formatAsPhoneNumber(phoneNumber: string) {
  // Format as 6-digit (xx xx xx); mobile|1800|1300 numbers (xxxx xxx xxx); or local number format (xx xxxx xxxx) where necessary
  if (phoneNumber.length === 6) {
    return phoneNumber.replace(/(\d{2})(\d{2})(\d{2})/, '$1 $2 $3');
  } else if (['04', '18', '13'].includes(phoneNumber.substr(0, 2))) {
    return phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
  }
  return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2 $3');
}
